import React, { Fragment } from 'react'
import SVGIcon from '../../../../../common/components/svgIcon'
import CityIcon from '../../../../images/city.svg'
import CountyIcon from '../../../../images/county.svg'

const iconsStyle = {
  display: 'inline',
  width: '20px',
  height: '20px',
  verticalAlign: 'middle',
  margin: '0 3px 2px 3px'
}

const CityIconString = <SVGIcon center file={CityIcon} style={iconsStyle} />

const CountyIconString = <SVGIcon center file={CountyIcon} style={iconsStyle} />

const CityCountyTooltip = () => {
  return (
    <Fragment>
      A city {CityIconString} and/or county {CountyIconString} posting exists for this location.
      City/county postings are included in your Update Subscription.
    </Fragment>
  )
}

export default CityCountyTooltip
